module.exports = __webpack_public_path__ + "static/workforcewindsoressex-logo-872dccd282b2a9b4cc16f7869e08bfce.png";